import { defineComponent as _defineComponent } from 'vue'
import { events } from '@/events';
import { useKennelCount } from '@/store/kennelCounts';
import { Dogspaces } from '@busy-human/k9-library';
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';



export default /*@__PURE__*/_defineComponent({
  __name: 'kennel-count',
  props: {
    day: {},
    month: {},
    year: {},
    kennel: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;
const kennelStore = useKennelCount();

// If count is null, number hasn't loaded
const count = ref<number | null>(null);

// const MAX_COLOR_INDEX = 4;

const colors = {
	"small":    "#00B2FF", // cyan
	"medium":   "#3300FF", // blue
	"large":    "#BD00FF", // fuchia
	// "large":    "#FF0037",
	"x-large":    "#FF6B00", // orange
	"xx-large":  "#DDFF00", // yellow
	// "green": "#00FF66", // green
};

// const countForBG = computed(() => Math.max(0, Math.min(count.value || 0, MAX_COLOR_INDEX)));

const opacityHexValue = [
	"00", "1A", "33", "4D", "66", "80", "99", "B3", "CC", "E6", "FF"
];

// Color based on kennel size + opacity; ie: 5 small kennels available = #00B2FF80
const color = computed(()=>`${colors[props.kennel]}${opacityHexValue[Math.min((count.value || 0), 10)]}`);
const color2 = computed(()=>`${colors[props.kennel]}`);

const countKey = computed(() => kennelStore.kennelCountKey(props.year, props.month + 1, props.day));

async function fetchCount() {
	count.value = null;
	const foundCount = await kennelStore.getKennelCount(countKey.value, props.kennel);
	count.value = foundCount;
}

onMounted(() => {
	console.log( " ON MOUNTED< PROPS: ", props);
	events.on("kennel:reload", fetchCount);
}

);
onUnmounted(() => events.off("kennel:reload", fetchCount));

watch(() => props, async () => {
	await fetchCount();
}, {deep: true, immediate: true});

const __returned__ = { props, kennelStore, count, colors, opacityHexValue, color, color2, countKey, fetchCount, get events() { return events }, get useKennelCount() { return useKennelCount }, get Dogspaces() { return Dogspaces }, computed, onMounted, onUnmounted, ref, watch }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})